'use strict';

const ToTime = require('./ToTime');

module.exports = ToTime;


//////////////////
// WEBPACK FOOTER
// ./~/to-time/src/index.js
// module id = 958
// module chunks = 0